<template>
  <div class="w-100 h-100 position-absolute shadow-bottom-container">
    <div class="shadow-bottom">
      <div class="shadow-bottom-row"></div>
      <div class="row m-0 w-100">
        <div class="col p-0">
          <a :href="url" :aria-label="name">
            <span class="name-label" v-html="name"></span>
            <span v-if="description" class="desc" v-html="description"></span>
          </a>
        </div>
        <div class="price-col col-auto p-0">
          <p v-if="priceCrossed" class="price-strikethrough">{{priceCrossed}}</p>
          <p class="price-label">{{price}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BlockShadowDesc",
  props: {
    url: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: null,
    },
    priceCrossed: {
      type: String,
      default: null,
    },
    price: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
};
</script>